import { useToast } from "@/components/Toast";

const GATEWAY_BASE =
  typeof window !== "undefined" ? `${window.location.protocol}//${window.location.host}` : "";

/** Copies a curl command equivalent to a logged request. Does NOT store the
 *  original request body, so the command is "re-send this call shape" — good
 *  for GETs and for debugging whether a route is still alive. Consumers add
 *  their own body with `-d` when needed.
 */
export function ReplayButton({
  method,
  path,
  label = "Replay",
}: {
  method: string;
  path: string;
  label?: string;
}) {
  const toast = useToast();
  function onClick(e: React.MouseEvent) {
    e.stopPropagation();
    const upper = method.toUpperCase();
    const lines = [
      `curl -sS -X ${upper} ${GATEWAY_BASE}${path} \\`,
      `  -H "X-Vault-Key: vlt_live_<paste-your-proxy-key>"`,
    ];
    if (upper === "POST" || upper === "PUT" || upper === "PATCH") {
      lines[0] = lines[0].replace(" \\", "");
      lines.push("  -H \"Content-Type: application/json\" \\");
      lines.push("  -d '{}' \\");
    }
    const snippet = lines.join("\n").replace(/\\\s*$/, "");
    navigator.clipboard.writeText(snippet);
    toast.success("Copied replay curl");
  }
  return (
    <button
      onClick={onClick}
      className="text-[10px] px-1.5 py-0.5 rounded border border-white/10 text-slate-400 hover:text-accent-500 hover:border-accent-500/30"
      title="Copy a curl command that re-sends this request shape"
    >
      {label}
    </button>
  );
}
